module.exports = __webpack_public_path__ + "img/clgd.7e5ac747.png";